var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-progress-circle",
      class: ["p" + _vm.value, _vm.value > 50 ? "over50" : ""],
    },
    [_c("span", [_vm._v(_vm._s(_vm.value) + " %")]), _vm._v(" "), _vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "left-half-clipper",
      },
      [
        _c("div", {
          staticClass: "first50-bar",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "value-bar",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }